"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationHistoryTwilioPhoneCallModelDirection = void 0;
exports.ConversationHistoryTwilioPhoneCallModelDirection = {
    Inbound: "inbound",
    Outbound: "outbound",
};
